<template>
  <div class="volume-meter-container" :style="{'grid-template-columns': `repeat(${scaleNumber}, 1fr)`}">
    <div
      :key="s"
      v-for="s in scaleNumber"
      class="meter-scale"
      :class="{'meter-scale--highlight': 100/scaleNumber*s <= volume}">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      volume: 0,
      scaleNumber: 70
    };
  },

  props: {
    deviceId: {
      type: String
    }
  },

  watch: {
    deviceId(v) {
      if (v) {
        this.setupMicVolumeMeter(v);
      }
    }
  },

  beforeDestroy() {
    this.stop();
    clearInterval(this._interval);
  },

  methods: {
    async setupMicVolumeMeter(deviceId) {
      // see https://stackoverflow.com/a/52952907
      try {
        let audioStream = await navigator.mediaDevices.getUserMedia({audio: {
          deviceId: {exact: deviceId}
        }});
        this._audioStream = audioStream;

        let audioContext = new AudioContext();
        this._audioContext = audioContext;

        let analyser = audioContext.createAnalyser();
        let processor = audioContext.createScriptProcessor(2048, 1, 1);
        analyser.smoothingTimeConstant = 0.8;
        analyser.fftSize = 1024;

        let track = audioContext.createMediaStreamSource(audioStream);
        track.connect(analyser);
        analyser.connect(processor);
        processor.connect(audioContext.destination);

        processor.onaudioprocess = () => {
          let array = new Uint8Array(analyser.frequencyBinCount);
          analyser.getByteFrequencyData(array);
          let values = 0;

          let length = array.length;
          for (let i = 0; i < length; i++) {
            values += (array[i]);
          }

          // TODO normalize volume value
          let average = values / length;
          this.volume = Math.round(average);
        };
      } catch (e) {
        log.error('failed to setup mic volume meter', e);
      }
    },

    async stop() {
      if (this._audioContext) {
        await this._audioContext.close();
      }
      if (this._audioStream) {
        this._audioStream.getTracks().forEach(track => track.stop());
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.volume-meter-container {
  overflow: hidden;
  width: 100%;
  // height: 2rem;
  // display: flex;
  // justify-content: space-around;

  display: grid;
  grid-template-rows: 2rem;
  grid-column-gap: 5px;
  justify-items: stretch;
  align-items: stretch;
}

.meter-scale {
  background-color: rgba(0,0,0,0.1);
}

.meter-scale--highlight {
  // background-color: $secondary-color;
  background-color: $success-color;
}
</style>
